var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BContainer',[_c('h3',[_vm._v("Change User")])])
}
var staticRenderFns = []

export { render, staticRenderFns }